import React from 'react';
import { Alert, Card, Form, Button } from 'react-bootstrap';
import { post_auth_json, set_token } from './util.js';
import { useNavigate } from 'react-router-dom';

function SignIn() {
  const [state, setState] = React.useState({
    username: "",
    password: "",
    error: null,
    isLoading: false
  });

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!state.username || !state.password) {
      setState({ ...state, error: "Please enter both username and password" });
      return;
    }

    setState({ ...state, isLoading: true, error: null });

    post_auth_json('/authenticate', {
      username: state.username,
      password: state.password
    }, (response) => {
      if (response.error || response.fruit !== 'apple') {
        setState({ 
          ...state, 
          error: "Invalid username or password", 
          isLoading: false,
          password: "" 
        });
        return;
      }

      set_token(response.token);
      navigate('/sources');
    });
  };

  return (
    <div className="container">
      <div className="row justify-content-center mt-5">
        <div className="col-md-6">
          <Card>
            <Card.Body className="p-4">
              <h2 className="text-center mb-4">Welcome to Feedfilter</h2>
              {state.error && (
                <Alert variant="danger" className="mb-3">
                  {state.error}
                </Alert>
              )}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    value={state.username}
                    onChange={(e) => setState({ ...state, username: e.target.value, error: null })}
                    placeholder="Enter username"
                    autoFocus
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={state.password}
                    onChange={(e) => setState({ ...state, password: e.target.value, error: null })}
                    placeholder="Enter password"
                  />
                </Form.Group>
                <div className="d-grid">
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={state.isLoading}
                  >
                    {state.isLoading ? 'Signing in...' : 'Sign in'}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default SignIn; 